module.exports = __webpack_public_path__ + "media/img/uploads/solutions-tall-thumb-04-b87e216fdd9d745ad7713d24d1c4f44f.jpg";